<app-onboarding-base-modal
  [heading]="heading"
  [bodyPrimary]="bodyPrimary"
  [bodySecondary]="bodySecondary"
  [primaryLabel]="primaryLabel"
  [secondaryLabel]="secondaryLabel"
  secondaryStyle="link"
  (dismissed)="closed.emit()"
  (primaryAction)="primaryAction.emit()"
  (secondaryAction)="secondaryAction.emit()"
></app-onboarding-base-modal>
